import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import Modal from '../../../common/Modal';
import { t } from '../../../../modules/infra/i18n';

const AddGiftCard = ({
  on,
  off,
  isOn,
  handleSubmit,
  pristine,
  valid,
  submitting,
}) => (
  <div>
    <button
      type="button"
      className="c-btn c-btn--medium u-width-120 u-ml"
      onClick={on}
    >
      {t('register:gift_cards.add.button')}
    </button>
    <Modal title={t('register:gift_cards.add.modal_title')} close={off} display-if={isOn}>
      <form onSubmit={handleSubmit} className="u-ph++ u-pv+">
        <div className="layout">
          <div className="layout__item u-1/2-large-and-up">
            <label className="c-label-new u-block" htmlFor="code">{t('register:gift_cards.add.code_label')}</label>
            <Input className="c-input c-input--white" id="code" name="code" placeholder={t('register:gift_cards.add.code_placeholder')} />
          </div>
          <div className="layout__item u-1/2-large-and-up">
            <label className="c-label-new u-block" htmlFor="initialBalance">{t('register:gift_cards.add.amount_label')}</label>
            <CurrencyInput
              className="c-input c-input--white"
              id="initialBalance"
              name="initialBalance"
              type="text"
              placeholder={t('register:gift_cards.add.amount_placeholder')}
            />
          </div>
        </div>
        <div className="u-text-center u-mt+">
          <button
            type="submit"
            className="c-btn c-btn--medium"
            disabled={submitting || pristine || !valid}
          >
            {t('register:gift_cards.add.submit_button')}
          </button>
        </div>
      </form>
    </Modal>
  </div>
);
AddGiftCard.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default AddGiftCard;
